import { useMutation } from '@apollo/client/react';
import { ResetPasswordDocument } from '@graphql/types';
import { useCallback } from 'react';

import type { ResetPasswordInput, ResetPasswordResponse } from '../types';

export const useResetPassword = () => {
  const [resetPasswordMutation, { loading }] = useMutation(ResetPasswordDocument);

  const doResetPassword = useCallback(
    async (input: ResetPasswordInput): Promise<ResetPasswordResponse> => {
      const response = await resetPasswordMutation({
        variables: { input },
      });
      const resetPasswordRes = response.data?.resetPassword;

      if (!resetPasswordRes) {
        throw new Error('Reset password failed');
      }

      return resetPasswordRes as ResetPasswordResponse;
    },
    [resetPasswordMutation]
  );

  return { doResetPassword, loading };
};
